export default {
    month: state => state.month,
    day: state => state.day,
    week: state => state.week,
    mySchedule: state => state.mySchedule,
    currentRota: state => state.currentRota,
    staffEmploymentTypes: state => state.staffEmploymentTypes,
    currentDate: state => state.currentDate,
}
